// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"SearchInput_searchInput__2APvB"};